'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _cms = require('actions/cms');

var _Creative = require('components/Creative/Creative');

var _Creative2 = _interopRequireDefault(_Creative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var data = state.cms.creative;
  var loading = state.cms.loading;

  var hero = {};
  var features = {};
  var spaces = {};
  var results = {};
  var clients = {};

  if (data !== null) {
    (function () {
      var page = data[0];
      var spacesItems = [];
      var resultsItems = [];
      var clientsLogos = [];
      var featureItems = [];

      for (var i = 1; i <= 3; i++) {
        page.getGroup('creative.item-' + i).toArray().map(function (item) {
          var copy = item.getStructuredText('copy').asHtml();
          var image = item.getImage('image').url;
          var title = item.getText('title');

          spacesItems.push({
            copy: copy,
            image: image,
            title: title
          });
        });
      }

      for (var ii = 1; ii <= 3; ii++) {
        page.getGroup('creative.result-' + ii).toArray().map(function (item) {
          var copy = item.getStructuredText('copy').asHtml();
          var value = item.getText('value');
          var title = item.getStructuredText('title').asHtml();

          resultsItems.push({
            copy: copy,
            value: value,
            title: title
          });
        });
      }

      page.getSliceZone('creative.feature').slices.map(function (item) {
        item.value.toArray().map(function (slice) {
          var copy = slice.getStructuredText('copy').asHtml();
          var icon = slice.getImage('icon').url;
          var title = slice.getText('title');

          featureItems.push({
            copy: copy,
            icon: icon,
            title: title
          });
        });
      });

      page.getGroup('creative.clients-logo').toArray().map(function (item) {
        var image = item.getImage('clients-logo-image').url;

        clientsLogos.push({
          image: image
        });
      });

      hero = {
        bg: page.getImage('creative.bg').url,
        strap: page.getStructuredText('creative.strap').asHtml()
      };

      features = {
        items: featureItems
      };

      spaces = {
        title: page.getText('creative.spaces-title'),
        strap: page.getStructuredText('creative.strapspaces').asHtml(),
        items: spacesItems
      };

      results = {
        title: page.getText('creative.results-title'),
        strap: page.getStructuredText('creative.strap-results').asHtml(),
        items: resultsItems
      };

      clients = {
        title: page.getText('creative.clients-title'),
        strap: page.getStructuredText('creative.clients-strap').asHtml(),
        logos: clientsLogos
      };
    })();
  }

  if (features.items && features.items.length && spaces.items && spaces.items.length && results.items && results.items.length && clients.logos && clients.logos.length) {
    return {
      hero: hero,
      spaces: spaces,
      results: results,
      clients: clients,
      loading: loading,
      features: features
    };
  } else {
    return {};
  }
}; /**
    * Creative
    *
    */


var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    fetchCreative: function fetchCreative() {
      dispatch((0, _cms.fetchCreative)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Creative2.default);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Creative.js
// module id = 345
// module chunks = 1